import { CxEvent } from '@spartacus/core';

export class Ga4GgUserLoginEvent extends CxEvent {
  event?: string;
}
